import Vue from 'vue';
import { Notification } from 'element-ui';

export const sleep = (callback, duration) => {
	const timers = setTimeout(() => {
		clearTimeout(timers);
		callback && callback();
	}, duration || 1000);

	return timers;
};

export const filterResponse = (t) => {
	const reg = /"content":"(.)"/;
	let res = '';

	t = t
		.replace(/data: /g, '')
		.split('\n\n')
		.filter((j) => j);
	t.forEach((i) => {
		// console.log(i)
		let s = i.indexOf('content":"');
		if (s !== -1) {
			let e = i.indexOf('"}');
			res += i.substring(s + 10, e);
		}

		// if (i && i.match(reg) && i.match(reg)[1]) {
		// 	res += i.match(reg)[1]
		// }
	});
	return res.replace(/\\n/g, '<br>');
};

// 下载
// @param  {String} url 目标文件地址
// @param  {String} filename 想要保存的文件名称
export function downloadFile(url, filename, item) {
	getBlob(
		url,
		function (blob) {
			saveAs(blob, filename);
		},
		item
	);
}

function getBlob(url, cb, item) {
	var xhr;
	if (window.XMLHttpRequest) {
		xhr = new XMLHttpRequest();
	} else {
		xhr = new ActiveXObject('Microsoft.XMLHTTP');
	}

	if (item) {
		const fileId = item.fileId + '-' + parseInt(Math.random() * 1000);

		const notify = Notification({
			showClose: false,
			duration: 0,
			title: item.resourceName,
			dangerouslyUseHTMLString: true,
			message: `<div>下载中 <span id="file-${fileId}">0%</span></div>`
		});

		xhr.onprogress = function (e) {
			e = e || event;
			if (e.lengthComputable) {
				let result =
					'Received ' + e.loaded + ' of ' + e.total + ' bytes';
				let p = parseInt((e.loaded / e.total) * 100);

				document.getElementById(`file-${fileId}`).innerHTML = p + '%';

				if (p == 100) {
					notify.close();
				}
			}
		};
	}

	xhr.open('GET', url, true);
	xhr.responseType = 'blob';
	xhr.onload = function () {
		if (xhr.status === 200) {
			cb(xhr.response);
		}
	};

	xhr.send();
}
// 保存
// @param  {Blob} blob
// @param  {String} filename 想要保存的文件名称
function saveAs(blob, filename) {
	if (window.navigator.msSaveOrOpenBlob) {
		navigator.msSaveBlob(blob, filename);
	} else {
		let link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = filename;
		link.click();
		window.URL.revokeObjectURL(link.href);
	}
}

// 获取URL参数
export const getQueryParams = (variable) => {
	var query = window.location.href.split('?')[1];
	if (!query) return false;
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		if (pair[0] == variable) {
			return pair[1];
		}
	}
	return false;
};
